import React from 'react';
import { useMsal, useAccount } from '@azure/msal-react';
import axios from "../axiosInstance";
import { apiAccessScopes } from "../authConfig";

interface RequestInterceptorProps {
    children: JSX.Element,
}

const RequestInterceptor: React.FC<RequestInterceptorProps> = ({ children }: RequestInterceptorProps) => {
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0]);

    axios.interceptors.request.use(async (config: any) => {
        if (!account) {
            throw Error('No active account! Verify a user has been signed in.');
        }

        const anotherTokenRequestResponse = await instance.acquireTokenSilent(apiAccessScopes);

        const bearer = `Bearer ${anotherTokenRequestResponse.accessToken}`;
        config.headers!['Authorization'] = bearer;
        config.headers!['x-employeeGuid'] = account.localAccountId;
        config.headers!['x-employeeId'] = typeof account.idTokenClaims?.['employeeId'] === "string" ? account.idTokenClaims?.['employeeId'] : undefined;
        config.headers!['x-jobTitle'] = typeof account.idTokenClaims?.['jobTitle'] === "string" ? account.idTokenClaims?.['jobTitle'] : undefined;
        config.headers!['x-branchName'] = typeof account.idTokenClaims?.['officeLocation'] === "string" ? account.idTokenClaims?.['officeLocation'] : undefined;

        return config;
    });

    return (
        <>
            {children}
        </>
    );
};

export default RequestInterceptor;